// @ts-ignore
import store from '../../../../../../../../../store';
import {Graphics, Sprite} from 'pixi.js';
import {StaticData} from '../../../../../../data/StaticData';
import {Back, gsap} from 'gsap';
import {VideoSeatMuteButton} from './bottom_bar/VideoSeatMuteButton';
import EventApi from '../../../../../../../../../api/EventsApi';
import {NameInput} from './bottom_bar/NameInput';

export class BottomBar extends Sprite
{
    graphicsBg: Graphics;
    appearTween: gsap.core.Tween | undefined;
    nameInput: NameInput;
    microphoneButton: VideoSeatMuteButton;
    cameraButton: VideoSeatMuteButton;

    constructor(private playerId: string) {
        super();

        this.graphicsBg = new Graphics();
        this.updateColor();
        this.addChild(this.graphicsBg);
        this.pivot.y = -StaticData.videoSeatBottomBarHeight;

        this.nameInput = new NameInput(this.playerId);

        this.microphoneButton = new VideoSeatMuteButton(
            '/images/video_seats/mic.svg',
            StaticData.videoSeatBottomBarMicEnabledColor,
            StaticData.videoSeatBottomBarMicDisbaledColor,
            this.onClickMic.bind(this)
        );
        this.cameraButton = new VideoSeatMuteButton(
            '/images/video_seats/cam.svg',
            StaticData.videoSeatBottomBarCamEnabledColor,
            StaticData.videoSeatBottomBarCamDisbaledColor,
            this.onClickCam.bind(this)
        );

        this.addChild(this.nameInput);
        this.addChild(this.microphoneButton);
        this.addChild(this.cameraButton);

        this.microphoneButton.x = StaticData.videoSeatSizes.x - 67 - StaticData.videoSeatBottomBarMuteButtonsRadius;
        this.cameraButton.x = StaticData.videoSeatSizes.x - 18 - StaticData.videoSeatBottomBarMuteButtonsRadius;
        this.nameInput.x = 76;

        this.microphoneButton.y = StaticData.videoSeatBottomBarHeight / 2;
        this.cameraButton.y = StaticData.videoSeatBottomBarHeight / 2;
        this.nameInput.y = StaticData.videoSeatBottomBarHeight / 2;

        this.updateMicrophoneButtonEnabled();
        this.updateCameraButtonEnabled();
    }

    updateColor(): void {
        this.graphicsBg.clear();
        this.graphicsBg.beginFill(StaticData.videoSeatBottomBarColor);
        this.graphicsBg.drawRoundedRect(0, 0, StaticData.videoSeatSizes.x, StaticData.videoSeatBottomBarHeight + 20, StaticData.videoSeatBorderRadius);
        this.graphicsBg.endFill();
    }

    appear(value: boolean = true): void {
        this.appearTween && this.appearTween.pause();
        this.appearTween = gsap.to(this.pivot, {
            y: value ? 0 : -StaticData.videoSeatBottomBarHeight,
            duration: .3,
            ease: value ? Back.easeOut : Back.easeIn
        });
    }

    destroy(): void {
        this.appearTween && this.appearTween.pause();
        super.destroy({children: true});
    }

    private onClickMic(): void {
        EventApi.triggerEvent(EventApi.TABLE_MICROPHONE);
        this.updateMicrophoneButtonEnabled();
    }

    private onClickCam(): void {
        EventApi.triggerEvent(EventApi.TABLE_CAMERA);
        this.updateCameraButtonEnabled();
    }

    private updateMicrophoneButtonEnabled() {
        this.microphoneButton.setEnabled(store.getters.getMicrophoneStatus);
    }

    private updateCameraButtonEnabled() {
        this.cameraButton.setEnabled(store.getters.getCameraStatus);
    }
}
